import { AutogenLayoutCarrierQualificationsList } from "./autogen/AutogenLayoutCarrierQualificationsList";


export class CarrierQualificationsList extends AutogenLayoutCarrierQualificationsList {

    override onLoad(): void {
        this.mainDataSource.search({});
    }
 }